import React, { createContext, useContext, useState, useEffect } from 'react';

// Translation data
const translations = {
  en: {
    // Dock Toolbar
    select: 'Select',
    draw: 'Draw',
    highlighter: 'Highlighter',
    erase: 'Erase',
    text: 'Text',
    undo: 'Undo',
    redo: 'Redo',
    deleteSelected: 'Delete Selected',
    handwritingToText: 'Handwriting to Text',
    save: 'Save',
    clearAll: 'Clear All',
    previousPage: 'Previous Page',
    nextPage: 'Next Page',
    addPage: 'Add Page',
    rectangle: 'Rectangle',
    circle: 'Circle',
    triangle: 'Triangle',
    line: 'Line',
    backgroundThemes: 'Background Themes',
    
    // Context Menu
    eeebeeSmartTools: 'EeeBee Smart Tools',
    eeebeeTeach: 'EeeBee Teach',
    findConcepts: 'Find concepts & explain',
    mathSolver: 'Math Solver',
    solveComplexEquations: 'Solve complex equations',
    findImages: 'Find Images',
    searchSimilarImages: 'Search for similar images',
    educationalVideos: 'Educational Videos',
    browseCurriculumVideos: 'Browse curriculum videos',
    '3dShapes': '3D Shapes',
    create3DGeometry: 'Create 3D geometry shapes',
    labSimulations: 'Lab Simulations',
    virtualScienceExperiments: 'Virtual science experiments',
    comingSoon: 'Coming Soon',
    learningAssistant: 'Learning assistant',
    aiPoweredHelp: 'AI-powered help',
    quizMode: 'Quiz Mode',
    interactiveQuizzes: 'Interactive quizzes',
    youtubeSearch: 'YouTube Search',
    searchYoutubeVideos: 'Search YouTube videos',
    webSearch: 'Web Search',
    searchTheWeb: 'Search the web',
    solveMath: 'Solve Math',
    stepByStepSolutions: 'Step-by-step solutions',
    explainConcept: 'Explain Concept',
    detailedExplanations: 'Detailed explanations',
    realWorldExamples: 'Real World Examples',
    practicalApplications: 'Practical applications',
    copyText: 'Copy Text',
    copyScanText: 'Copy scanned text',
    
    // Learning Options
    learningOptions: 'Learning Options',
    explain: 'Explain',
    provideDetailedExplanation: 'Provide detailed explanation',
    quiz: 'Quiz',
    createQuizQuestions: 'Create quiz questions',
    realWorld: 'Real World',
    showPracticalApplications: 'Show practical applications',
    youtubeVideos: 'YouTube Videos',
    findEducationalVideos: 'Find educational videos',
    translate: 'Translate',
    translateToLanguage: 'Translate to another language',
    copy: 'Copy',
    copyTextToClipboard: 'Copy text to clipboard',
    
    // AI Tools
    eeebeeAITools: 'EeeBee AI Tools',
    aiAssistant: 'AI Assistant',
    lessonPlanGenerator: 'Lesson Plan Generator',
    
    // Settings
    educationSettings: 'Education Settings',
    educationBoard: 'Education Board',
    gradeLevel: 'Grade Level',
    subject: 'Subject',
    chapter: 'Chapter',
    language: 'Language',
    selectBoard: 'Select Board',
    selectGrade: 'Select Grade',
    selectSubject: 'Select Subject',
    educationSettings: 'Education Settings',
    allChapters: 'All Chapters',
    showConcepts: 'Show Concepts',
    openEbook: 'Open Ebook',
    
    // Unified Concept Explainer
    explanation: 'Explanation',
    visualAids: 'Visual Aids',
    practiceQuestions: 'Practice Questions',
    videos: 'Videos',
    practice: 'Practice',
    noImagesAvailable: 'No images available',
    noVideosAvailable: 'No videos available',
    noQuestionsAvailable: 'No practice questions available',
    
    // Messages
    noTextFound: 'No text found',
    processing: 'Processing...',
    failed: 'Failed',
    success: 'Success',
    error: 'Error',
    loading: 'Loading...',
    searchingImages: 'Searching for images...',
    generatingLessonPlan: 'Generating lesson plan...',
    convertingHandwriting: 'Converting handwriting...',
    solving: 'Solving...',
    explaining: 'Explaining...',
    noMathFound: 'No math expression found',
    mathSolverError: 'Failed to solve math problem',
    drawRectangleMath: 'Draw a rectangle around the math problem',
    class: 'Class',
    noTextToExplain: 'No text found to explain',
    explainError: 'Failed to explain concept',
    drawRectangleExplain: 'Draw a rectangle around the concept to explain',
    
    // AI Panel
    eeebeeAssistant: 'EeeBee Assistant',
    aiPanelWelcome: 'Hello! I\'m EeeBee, your educational assistant. I can see your whiteboard and help you with any questions. I can solve math problems, explain concepts, analyze what\'s on the board, or assist with anything else you need!',
    eeebeeThinking: 'EeeBee is thinking...',
    askAnything: 'Ask anything about the whiteboard...',
    
    // PPT Generator
    generatePPT: 'Generate PowerPoint',
    conceptsToLearn: 'Concepts to Learn',
    conceptExplanation: 'Concept Explanation',
    
    // Educational Boards
    cbse: 'CBSE',
    icse: 'ICSE',
    ib: 'IB',
    cambridge: 'Cambridge',
    state: 'State Board',
    american: 'American',
    british: 'British',
    australian: 'Australian',
    gaokao: 'Gaokao',
    zhongkao: 'Zhongkao',
    chinese: 'Chinese National',
    
    // Countries
    India: 'India',
    International: 'International',
    USA: 'USA',
    UK: 'UK',
    Australia: 'Australia',
    China: 'China',
    
    // Subjects
    mathematics: 'Mathematics',
    science: 'Science',
    physics: 'Physics',
    chemistry: 'Chemistry',
    biology: 'Biology',
    english: 'English',
    hindi: 'Hindi',
    socialscience: 'Social Science',
    socialstudies: 'Social Studies',
    computerscience: 'Computer Science',
    computerapplications: 'Computer Applications',
    history: 'History',
    historycivics: 'History & Civics',
    geography: 'Geography',
    economics: 'Economics',
    business: 'Business Studies',
    regionallanguage: 'Regional Language',
    languageliterature: 'Language & Literature',
    languageacquisition: 'Language Acquisition',
    individualssocieties: 'Individuals & Societies',
    sciences: 'Sciences',
    arts: 'Arts',
    languages: 'Languages',
    humanities: 'Humanities',
    creativeprofessional: 'Creative & Professional',
    computing: 'Computing',
    math: 'Math',
    englishlanguagearts: 'English Language Arts',
    foreignlanguage: 'Foreign Language',
    modernforeignlanguages: 'Modern Foreign Languages',
    artdesign: 'Art & Design',
    hass: 'HASS',
    technologies: 'Technologies',
    chinese: 'Chinese',
    politics: 'Politics',
    informationtechnology: 'Information Technology',
    physicaleducation: 'Physical Education',
    
    // Quiz Mode
    createNewQuiz: 'Create New Quiz',
    generateAIPoweredQuiz: 'Generate an AI-powered quiz with customizable settings',
    optional: 'Optional',
    numberOfQuestions: 'Number of Questions',
    questions: 'Questions',
    timePerQuestion: 'Time per Question',
    seconds: 'seconds',
    minute: 'minute',
    minutes: 'minutes',
    difficultyLevel: 'Difficulty Level',
    easy: 'Easy',
    medium: 'Medium',
    hard: 'Hard',
    mixed: 'Mixed',
    questionTypes: 'Question Types',
    multipleChoice: 'Multiple Choice',
    trueFalse: 'True/False',
    mixedTypes: 'Mixed Types',
    generateQuiz: 'Generate Quiz',
    difficulty: 'Difficulty',
    individualQuiz: 'Individual Quiz',
    startQuiz: 'Start Quiz',
    backToSetup: 'Back to Setup',
    question: 'Question',
    of: 'of',
    points: 'points',
    hint: 'Hint',
    previous: 'Previous',
    pause: 'Pause',
    resume: 'Resume',
    finishQuiz: 'Finish Quiz',
    finish: 'Finish',
    continue: 'Continue',
    next: 'Next',
    quizResults: 'Quiz Results',
    grade: 'Grade',
    correctAnswers: 'Correct Answers',
    totalQuestions: 'Total Questions',
    pointsEarned: 'Points Earned',
    questionBreakdown: 'Question Breakdown',
    yourAnswer: 'Your Answer',
    notAnswered: 'Not answered',
    correctAnswer: 'Correct Answer',
    addToWhiteboard: 'Add to Whiteboard',
    exportResults: 'Export Results',
    takeAnotherQuiz: 'Take Another Quiz',
    aiQuizMode: 'AI Quiz Mode',
    pleaseSelectBoardGradeSubject: 'Please select education board, grade level, and subject',
    quizGeneratedSuccessfully: 'Quiz generated successfully!',
    quizResultsAddedToWhiteboard: 'Quiz results added to whiteboard!',
    quizResultsExportedSuccessfully: 'Quiz results exported successfully!',
    greatJob: 'Great job!',
    learningOpportunity: 'Learning Opportunity:',
    noExplanationAvailable: 'No explanation available for this question',
    remember: 'Remember',
    clickContinueToNext: 'Click Continue to proceed to the next question',
    
    // Concepts Panel
    chapterConcepts: 'Chapter Concepts',
    analyzing: 'Analyzing',
    generatingKeyConcepts: 'Generating key concepts for better understanding',
    startTeachingMode: 'Start Teaching Mode',
    closePanel: 'Close Panel',
    examples: 'Examples',
    visualRepresentation: 'Visual Representation',
    visualLearning: 'Visual Learning',
    loadingVideos: 'Loading videos...',
    loadingImages: 'Loading images...',
    testYourKnowledge: 'Test Your Knowledge',
    close: 'Close',
    clickToAddToBoard: 'Click to add to board',
    stopTeaching: 'Stop Teaching',
    pleaseWaitWhileFetchingContent: 'Please wait while we fetch content...'
  },
  
  hi: {
    // Dock Toolbar
    select: 'चुनें',
    draw: 'ड्रॉ करें',
    highlighter: 'हाइलाइटर',
    erase: 'मिटाएं',
    text: 'टेक्स्ट',
    undo: 'पूर्ववत करें',
    redo: 'फिर से करें',
    deleteSelected: 'चयनित हटाएं',
    handwritingToText: 'हस्तलेखन से टेक्स्ट',
    save: 'सहेजें',
    clearAll: 'सब साफ करें',
    previousPage: 'पिछला पृष्ठ',
    nextPage: 'अगला पृष्ठ',
    addPage: 'पृष्ठ जोड़ें',
    rectangle: 'आयत',
    circle: 'वृत्त',
    triangle: 'त्रिभुज',
    line: 'रेखा',
    backgroundThemes: 'पृष्ठभूमि थीम',
    
    // Context Menu
    eeebeeSmartTools: 'ईबी स्मार्ट टूल्स',
    eeebeeTeach: 'ईबी टीच',
    findConcepts: 'अवधारणाएं खोजें और समझाएं',
    mathSolver: 'गणित सॉल्वर',
    solveComplexEquations: 'जटिल समीकरण हल करें',
    findImages: 'चित्र खोजें',
    searchSimilarImages: 'समान चित्र खोजें',
    educationalVideos: 'शैक्षणिक वीडियो',
    browseCurriculumVideos: 'पाठ्यक्रम वीडियो ब्राउज़ करें',
    '3dShapes': '3D आकार',
    create3DGeometry: '3D ज्यामिति आकार बनाएं',
    labSimulations: 'लैब सिमुलेशन',
    virtualScienceExperiments: 'वर्चुअल विज्ञान प्रयोग',
    comingSoon: 'जल्द आ रहा है',
    learningAssistant: 'शिक्षण सहायक',
    aiPoweredHelp: 'AI-संचालित सहायता',
    quizMode: 'प्रश्नोत्तरी मोड',
    interactiveQuizzes: 'इंटरैक्टिव प्रश्नोत्तरी',
    youtubeSearch: 'यूट्यूब खोज',
    searchYoutubeVideos: 'यूट्यूब वीडियो खोजें',
    webSearch: 'वेब खोज',
    searchTheWeb: 'वेब पर खोजें',
    solveMath: 'गणित हल करें',
    stepByStepSolutions: 'चरणबद्ध समाधान',
    explainConcept: 'अवधारणा समझाएं',
    detailedExplanations: 'विस्तृत व्याख्याएं',
    realWorldExamples: 'वास्तविक दुनिया के उदाहरण',
    practicalApplications: 'व्यावहारिक अनुप्रयोग',
    copyText: 'टेक्स्ट कॉपी करें',
    copyScanText: 'स्कैन किया गया टेक्स्ट कॉपी करें',
    
    // Learning Options
    learningOptions: 'सीखने के विकल्प',
    explain: 'समझाएं',
    provideDetailedExplanation: 'विस्तृत व्याख्या प्रदान करें',
    quiz: 'प्रश्नोत्तरी',
    createQuizQuestions: 'प्रश्नोत्तरी प्रश्न बनाएं',
    realWorld: 'वास्तविक दुनिया',
    showPracticalApplications: 'व्यावहारिक अनुप्रयोग दिखाएं',
    youtubeVideos: 'यूट्यूब वीडियो',
    findEducationalVideos: 'शैक्षणिक वीडियो खोजें',
    translate: 'अनुवाद करें',
    translateToLanguage: 'दूसरी भाषा में अनुवाद करें',
    copy: 'कॉपी करें',
    copyTextToClipboard: 'टेक्स्ट को क्लिपबोर्ड पर कॉपी करें',
    
    // AI Tools
    eeebeeAITools: 'ईबी AI टूल्स',
    aiAssistant: 'AI सहायक',
    lessonPlanGenerator: 'पाठ योजना जनरेटर',
    
    // Settings
    educationSettings: 'शिक्षा सेटिंग्स',
    educationBoard: 'शिक्षा बोर्ड',
    gradeLevel: 'कक्षा स्तर',
    subject: 'विषय',
    chapter: 'अध्याय',
    language: 'भाषा',
    selectBoard: 'बोर्ड चुनें',
    selectGrade: 'कक्षा चुनें',
    selectSubject: 'विषय चुनें',
    allChapters: 'सभी अध्याय',
    showConcepts: 'अवधारणाएं दिखाएं',
    openEbook: 'ई-बुक खोलें',
    
    // Unified Concept Explainer
    explanation: 'व्याख्या',
    visualAids: 'दृश्य सामग्री',
    practiceQuestions: 'अभ्यास प्रश्न',
    videos: 'वीडियो',
    practice: 'अभ्यास',
    noImagesAvailable: 'कोई चित्र उपलब्ध नहीं',
    noVideosAvailable: 'कोई वीडियो उपलब्ध नहीं',
    noQuestionsAvailable: 'कोई अभ्यास प्रश्न उपलब्ध नहीं',
    
    // Messages
    noTextFound: 'कोई टेक्स्ट नहीं मिला',
    processing: 'प्रसंस्करण...',
    failed: 'असफल',
    success: 'सफल',
    error: 'त्रुटि',
    loading: 'लोड हो रहा है...',
    searchingImages: 'चित्र खोज रहे हैं...',
    generatingLessonPlan: 'पाठ योजना बना रहे हैं...',
    convertingHandwriting: 'हस्तलेखन परिवर्तित कर रहे हैं...',
    solving: 'हल कर रहे हैं...',
    explaining: 'समझा रहे हैं...',
    noMathFound: 'कोई गणित अभिव्यक्ति नहीं मिली',
    mathSolverError: 'गणित समस्या हल करने में विफल',
    drawRectangleMath: 'गणित समस्या के चारों ओर एक आयत बनाएं',
    class: 'कक्षा',
    noTextToExplain: 'समझाने के लिए कोई पाठ नहीं मिला',
    explainError: 'अवधारणा की व्याख्या करने में विफल',
    drawRectangleExplain: 'समझाने के लिए अवधारणा के चारों ओर एक आयत बनाएं',
    
    // AI Panel
    eeebeeAssistant: 'ईबी सहायक',
    aiPanelWelcome: 'नमस्ते! मैं ईबी हूं, आपका शैक्षणिक सहायक। मैं आपके व्हाइटबोर्ड को देख सकता हूं और किसी भी प्रश्न में आपकी मदद कर सकता हूं। मैं गणित की समस्याओं को हल कर सकता हूं, अवधारणाओं की व्याख्या कर सकता हूं, बोर्ड पर क्या है इसका विश्लेषण कर सकता हूं, या आपकी आवश्यकता के अनुसार कुछ भी सहायता कर सकता हूं!',
    eeebeeThinking: 'ईबी सोच रहा है...',
    askAnything: 'व्हाइटबोर्ड के बारे में कुछ भी पूछें...',
    
    // PPT Generator
    generatePPT: 'पावरपॉइंट बनाएं',
    conceptsToLearn: 'सीखने के लिए अवधारणाएं',
    conceptExplanation: 'अवधारणा स्पष्टीकरण',
    
    // Educational Boards
    cbse: 'सीबीएसई',
    icse: 'आईसीएसई',
    ib: 'आईबी',
    cambridge: 'कैम्ब्रिज',
    state: 'राज्य बोर्ड',
    
    // Subjects
    mathematics: 'गणित',
    physics: 'भौतिक विज्ञान',
    chemistry: 'रसायन विज्ञान',
    biology: 'जीव विज्ञान',
    english: 'अंग्रेजी',
    computerScience: 'कंप्यूटर विज्ञान',
    history: 'इतिहास',
    geography: 'भूगोल',
    economics: 'अर्थशास्त्र',
    business: 'व्यावसायिक अध्ययन',
    
    // Quiz Mode
    createNewQuiz: 'नई प्रश्नोत्तरी बनाएं',
    generateAIPoweredQuiz: 'अनुकूलन योग्य सेटिंग्स के साथ एआई-संचालित प्रश्नोत्तरी उत्पन्न करें',
    optional: 'वैकल्पिक',
    numberOfQuestions: 'प्रश्नों की संख्या',
    questions: 'प्रश्न',
    timePerQuestion: 'प्रति प्रश्न समय',
    seconds: 'सेकंड',
    minute: 'मिनट',
    minutes: 'मिनट',
    difficultyLevel: 'कठिनाई स्तर',
    easy: 'आसान',
    medium: 'मध्यम',
    hard: 'कठिन',
    mixed: 'मिश्रित',
    questionTypes: 'प्रश्न के प्रकार',
    multipleChoice: 'बहुविकल्पीय',
    trueFalse: 'सत्य/असत्य',
    mixedTypes: 'मिश्रित प्रकार',
    generateQuiz: 'प्रश्नोत्तरी उत्पन्न करें',
    difficulty: 'कठिनाई',
    individualQuiz: 'व्यक्तिगत प्रश्नोत्तरी',
    startQuiz: 'प्रश्नोत्तरी शुरू करें',
    backToSetup: 'सेटअप पर वापस जाएं',
    question: 'प्रश्न',
    of: 'का',
    points: 'अंक',
    hint: 'संकेत',
    previous: 'पिछला',
    pause: 'रोकें',
    resume: 'फिर से शुरू करें',
    finishQuiz: 'प्रश्नोत्तरी समाप्त करें',
    finish: 'समाप्त',
    continue: 'जारी रखें',
    next: 'अगला',
    quizResults: 'प्रश्नोत्तरी परिणाम',
    grade: 'ग्रेड',
    correctAnswers: 'सही उत्तर',
    totalQuestions: 'कुल प्रश्न',
    pointsEarned: 'अर्जित अंक',
    questionBreakdown: 'प्रश्न विवरण',
    yourAnswer: 'आपका उत्तर',
    notAnswered: 'उत्तर नहीं दिया',
    correctAnswer: 'सही उत्तर',
    addToWhiteboard: 'व्हाइटबोर्ड में जोड़ें',
    exportResults: 'परिणाम निर्यात करें',
    takeAnotherQuiz: 'एक और प्रश्नोत्तरी लें',
    aiQuizMode: 'एआई प्रश्नोत्तरी मोड',
    pleaseSelectBoardGradeSubject: 'कृपया शिक्षा बोर्ड, कक्षा स्तर और विषय चुनें',
    quizGeneratedSuccessfully: 'प्रश्नोत्तरी सफलतापूर्वक उत्पन्न हुई!',
    quizResultsAddedToWhiteboard: 'प्रश्नोत्तरी परिणाम व्हाइटबोर्ड में जोड़े गए!',
    quizResultsExportedSuccessfully: 'प्रश्नोत्तरी परिणाम सफलतापूर्वक निर्यात किए गए!',
    greatJob: 'बहुत बढ़िया!',
    learningOpportunity: 'सीखने का अवसर:',
    noExplanationAvailable: 'इस प्रश्न के लिए कोई स्पष्टीकरण उपलब्ध नहीं है',
    remember: 'याद रखें',
    clickContinueToNext: 'अगले प्रश्न पर जाने के लिए जारी रखें पर क्लिक करें',
    
    // Concepts Panel
    chapterConcepts: 'अध्याय अवधारणाएं',
    analyzing: 'विश्लेषण कर रहे हैं',
    generatingKeyConcepts: 'बेहतर समझ के लिए मुख्य अवधारणाएं उत्पन्न कर रहे हैं',
    startTeachingMode: 'शिक्षण मोड शुरू करें',
    closePanel: 'पैनल बंद करें',
    examples: 'उदाहरण',
    visualRepresentation: 'दृश्य प्रतिनिधित्व',
    visualLearning: 'दृश्य शिक्षा',
    loadingVideos: 'वीडियो लोड हो रहे हैं...',
    loadingImages: 'चित्र लोड हो रहे हैं...',
    testYourKnowledge: 'अपना ज्ञान परखें',
    close: 'बंद करें',
    clickToAddToBoard: 'बोर्ड में जोड़ने के लिए क्लिक करें',
    stopTeaching: 'शिक्षण रोकें',
    pleaseWaitWhileFetchingContent: 'कृपया प्रतीक्षा करें जब हम सामग्री प्राप्त कर रहे हैं...'
  },
  
  es: {
    // Dock Toolbar
    select: 'Seleccionar',
    draw: 'Dibujar',
    highlighter: 'Resaltador',
    erase: 'Borrar',
    text: 'Texto',
    undo: 'Deshacer',
    redo: 'Rehacer',
    deleteSelected: 'Eliminar Seleccionado',
    handwritingToText: 'Escritura a Texto',
    save: 'Guardar',
    clearAll: 'Borrar Todo',
    previousPage: 'Página Anterior',
    nextPage: 'Página Siguiente',
    addPage: 'Añadir Página',
    rectangle: 'Rectángulo',
    circle: 'Círculo',
    triangle: 'Triángulo',
    line: 'Línea',
    backgroundThemes: 'Temas de Fondo',
    
    // Context Menu
    eeebeeSmartTools: 'Herramientas Inteligentes EeeBee',
    eeebeeTeach: 'EeeBee Enseña',
    findConcepts: 'Encontrar conceptos y explicar',
    mathSolver: 'Solucionador de Matemáticas',
    solveComplexEquations: 'Resolver ecuaciones complejas',
    findImages: 'Buscar Imágenes',
    searchSimilarImages: 'Buscar imágenes similares',
    educationalVideos: 'Videos Educativos',
    browseCurriculumVideos: 'Explorar videos del plan de estudios',
    '3dShapes': 'Formas 3D',
    create3DGeometry: 'Crear formas geométricas 3D',
    labSimulations: 'Simulaciones de Laboratorio',
    virtualScienceExperiments: 'Experimentos científicos virtuales',
    comingSoon: 'Próximamente',
    learningAssistant: 'Asistente de aprendizaje',
    aiPoweredHelp: 'Ayuda con IA',
    quizMode: 'Modo Cuestionario',
    interactiveQuizzes: 'Cuestionarios interactivos',
    youtubeSearch: 'Búsqueda de YouTube',
    searchYoutubeVideos: 'Buscar videos de YouTube',
    webSearch: 'Búsqueda Web',
    searchTheWeb: 'Buscar en la web',
    solveMath: 'Resolver Matemáticas',
    stepByStepSolutions: 'Soluciones paso a paso',
    explainConcept: 'Explicar Concepto',
    detailedExplanations: 'Explicaciones detalladas',
    realWorldExamples: 'Ejemplos del Mundo Real',
    practicalApplications: 'Aplicaciones prácticas',
    copyText: 'Copiar Texto',
    copyScanText: 'Copiar texto escaneado',
    
    // Learning Options
    learningOptions: 'Opciones de Aprendizaje',
    explain: 'Explicar',
    provideDetailedExplanation: 'Proporcionar explicación detallada',
    quiz: 'Cuestionario',
    createQuizQuestions: 'Crear preguntas de cuestionario',
    realWorld: 'Mundo Real',
    showPracticalApplications: 'Mostrar aplicaciones prácticas',
    youtubeVideos: 'Videos de YouTube',
    findEducationalVideos: 'Encontrar videos educativos',
    translate: 'Traducir',
    translateToLanguage: 'Traducir a otro idioma',
    copy: 'Copiar',
    copyTextToClipboard: 'Copiar texto al portapapeles',
    
    // AI Tools
    eeebeeAITools: 'Herramientas AI de EeeBee',
    aiAssistant: 'Asistente AI',
    lessonPlanGenerator: 'Generador de Plan de Lección',
    
    // Settings
    educationBoard: 'Consejo de Educación',
    gradeLevel: 'Nivel de Grado',
    subject: 'Asignatura',
    chapter: 'Capítulo',
    language: 'Idioma',
    selectBoard: 'Seleccionar Consejo',
    selectGrade: 'Seleccionar Grado',
    selectSubject: 'Seleccionar Asignatura',
    allChapters: 'Todos los Capítulos',
    showConcepts: 'Mostrar Conceptos',
    openEbook: 'Abrir Libro Electrónico',
    
    // Unified Concept Explainer
    explanation: 'Explicación',
    visualAids: 'Ayudas Visuales',
    practiceQuestions: 'Preguntas de Práctica',
    videos: 'Videos',
    practice: 'Práctica',
    noImagesAvailable: 'No hay imágenes disponibles',
    noVideosAvailable: 'No hay videos disponibles',
    noQuestionsAvailable: 'No hay preguntas de práctica disponibles',
    
    // Messages
    noTextFound: 'No se encontró texto',
    processing: 'Procesando...',
    failed: 'Falló',
    success: 'Éxito',
    error: 'Error',
    loading: 'Cargando...',
    searchingImages: 'Buscando imágenes...',
    generatingLessonPlan: 'Generando plan de lección...',
    convertingHandwriting: 'Convirtiendo escritura...',
    solving: 'Resolviendo...',
    explaining: 'Explicando...',
    noMathFound: 'No se encontró expresión matemática',
    mathSolverError: 'Error al resolver problema matemático',
    drawRectangleMath: 'Dibuja un rectángulo alrededor del problema matemático',
    class: 'Clase',
    noTextToExplain: 'No se encontró texto para explicar',
    explainError: 'Error al explicar el concepto',
    drawRectangleExplain: 'Dibuja un rectángulo alrededor del concepto para explicar',
    
    // AI Panel
    eeebeeAssistant: 'Asistente EeeBee',
    aiPanelWelcome: '¡Hola! Soy EeeBee, tu asistente educativo. Puedo ver tu pizarra y ayudarte con cualquier pregunta. ¡Puedo resolver problemas matemáticos, explicar conceptos, analizar lo que está en la pizarra o ayudarte con cualquier otra cosa que necesites!',
    eeebeeThinking: 'EeeBee está pensando...',
    askAnything: 'Pregunta cualquier cosa sobre la pizarra...',
    
    // PPT Generator
    generatePPT: 'Generar PowerPoint',
    conceptsToLearn: 'Conceptos para Aprender',
    conceptExplanation: 'Explicación del Concepto',
    
    // Educational Boards
    cbse: 'CBSE',
    icse: 'ICSE',
    ib: 'IB',
    cambridge: 'Cambridge',
    state: 'Consejo Estatal',
    
    // Subjects
    mathematics: 'Matemáticas',
    physics: 'Física',
    chemistry: 'Química',
    biology: 'Biología',
    english: 'Inglés',
    computerScience: 'Ciencias de la Computación',
    history: 'Historia',
    geography: 'Geografía',
    economics: 'Economía',
    business: 'Estudios Empresariales',
    
    // Quiz Mode
    createNewQuiz: 'Crear Nuevo Cuestionario',
    generateAIPoweredQuiz: 'Generar un cuestionario impulsado por IA con configuraciones personalizables',
    optional: 'Opcional',
    numberOfQuestions: 'Número de Preguntas',
    questions: 'Preguntas',
    timePerQuestion: 'Tiempo por Pregunta',
    seconds: 'segundos',
    minute: 'minuto',
    minutes: 'minutos',
    difficultyLevel: 'Nivel de Dificultad',
    easy: 'Fácil',
    medium: 'Medio',
    hard: 'Difícil',
    mixed: 'Mixto',
    questionTypes: 'Tipos de Preguntas',
    multipleChoice: 'Opción Múltiple',
    trueFalse: 'Verdadero/Falso',
    mixedTypes: 'Tipos Mixtos',
    generateQuiz: 'Generar Cuestionario',
    difficulty: 'Dificultad',
    individualQuiz: 'Cuestionario Individual',
    startQuiz: 'Iniciar Cuestionario',
    backToSetup: 'Volver a Configuración',
    question: 'Pregunta',
    of: 'de',
    points: 'puntos',
    hint: 'Pista',
    previous: 'Anterior',
    pause: 'Pausar',
    resume: 'Reanudar',
    finishQuiz: 'Finalizar Cuestionario',
    finish: 'Finalizar',
    continue: 'Continuar',
    next: 'Siguiente',
    quizResults: 'Resultados del Cuestionario',
    grade: 'Calificación',
    correctAnswers: 'Respuestas Correctas',
    totalQuestions: 'Total de Preguntas',
    pointsEarned: 'Puntos Obtenidos',
    questionBreakdown: 'Desglose de Preguntas',
    yourAnswer: 'Tu Respuesta',
    notAnswered: 'No respondida',
    correctAnswer: 'Respuesta Correcta',
    addToWhiteboard: 'Añadir a la Pizarra',
    exportResults: 'Exportar Resultados',
    takeAnotherQuiz: 'Tomar Otro Cuestionario',
    aiQuizMode: 'Modo Cuestionario AI',
    pleaseSelectBoardGradeSubject: 'Por favor seleccione consejo de educación, nivel de grado y asignatura',
    quizGeneratedSuccessfully: '¡Cuestionario generado exitosamente!',
    quizResultsAddedToWhiteboard: '¡Resultados del cuestionario añadidos a la pizarra!',
    quizResultsExportedSuccessfully: '¡Resultados del cuestionario exportados exitosamente!',
    greatJob: '¡Excelente trabajo!',
    learningOpportunity: 'Oportunidad de Aprendizaje:',
    noExplanationAvailable: 'No hay explicación disponible para esta pregunta',
    remember: 'Recuerda',
    clickContinueToNext: 'Haz clic en Continuar para proceder a la siguiente pregunta',
    
    // Concepts Panel
    chapterConcepts: 'Conceptos del Capítulo',
    analyzing: 'Analizando',
    generatingKeyConcepts: 'Generando conceptos clave para una mejor comprensión',
    startTeachingMode: 'Iniciar Modo de Enseñanza',
    closePanel: 'Cerrar Panel',
    examples: 'Ejemplos',
    visualRepresentation: 'Representación Visual',
    visualLearning: 'Aprendizaje Visual',
    loadingVideos: 'Cargando videos...',
    loadingImages: 'Cargando imágenes...',
    testYourKnowledge: 'Prueba Tu Conocimiento',
    close: 'Cerrar',
    clickToAddToBoard: 'Haz clic para añadir al tablero',
    stopTeaching: 'Detener Enseñanza',
    pleaseWaitWhileFetchingContent: 'Por favor espera mientras obtenemos el contenido...'
  },
  
  zh: {
    // Dock Toolbar
    select: '选择',
    draw: '绘图',
    highlighter: '荧光笔',
    erase: '擦除',
    text: '文字',
    undo: '撤销',
    redo: '重做',
    deleteSelected: '删除选中',
    handwritingToText: '手写转文字',
    save: '保存',
    clearAll: '清除全部',
    previousPage: '上一页',
    nextPage: '下一页',
    addPage: '添加页面',
    rectangle: '矩形',
    circle: '圆形',
    triangle: '三角形',
    line: '线条',
    backgroundThemes: '背景主题',
    
    // Context Menu
    eeebeeSmartTools: 'EeeBee 智能工具',
    eeebeeTeach: 'EeeBee 教学',
    findConcepts: '查找概念并解释',
    mathSolver: '数学求解器',
    solveComplexEquations: '解决复杂方程',
    findImages: '查找图片',
    searchSimilarImages: '搜索相似图片',
    educationalVideos: '教育视频',
    browseCurriculumVideos: '浏览课程视频',
    '3dShapes': '3D 形状',
    create3DGeometry: '创建 3D 几何形状',
    labSimulations: '实验室模拟',
    virtualScienceExperiments: '虚拟科学实验',
    comingSoon: '即将推出',
    learningAssistant: '学习助手',
    aiPoweredHelp: 'AI 驱动的帮助',
    quizMode: '测验模式',
    interactiveQuizzes: '互动测验',
    youtubeSearch: 'YouTube 搜索',
    searchYoutubeVideos: '搜索 YouTube 视频',
    webSearch: '网络搜索',
    searchTheWeb: '搜索网络',
    solveMath: '解决数学',
    stepByStepSolutions: '逐步解决方案',
    explainConcept: '解释概念',
    detailedExplanations: '详细解释',
    realWorldExamples: '现实世界示例',
    practicalApplications: '实际应用',
    copyText: '复制文本',
    copyScanText: '复制扫描文本',
    
    // Learning Options
    learningOptions: '学习选项',
    explain: '解释',
    provideDetailedExplanation: '提供详细解释',
    quiz: '测验',
    createQuizQuestions: '创建测验问题',
    realWorld: '现实世界',
    showPracticalApplications: '展示实际应用',
    youtubeVideos: 'YouTube 视频',
    findEducationalVideos: '查找教育视频',
    translate: '翻译',
    translateToLanguage: '翻译成其他语言',
    copy: '复制',
    copyTextToClipboard: '复制文本到剪贴板',
    
    // AI Tools
    eeebeeAITools: 'EeeBee AI 工具',
    aiAssistant: 'AI 助手',
    lessonPlanGenerator: '课程计划生成器',
    
    // Settings
    educationSettings: '教育设置',
    educationBoard: '教育委员会',
    gradeLevel: '年级',
    subject: '学科',
    chapter: '章节',
    language: '语言',
    selectBoard: '选择委员会',
    selectGrade: '选择年级',
    selectSubject: '选择学科',
    allChapters: '所有章节',
    showConcepts: '显示概念',
    openEbook: '打开电子书',
    
    // Unified Concept Explainer
    explanation: '解释',
    visualAids: '视觉辅助',
    practiceQuestions: '练习题',
    videos: '视频',
    practice: '练习',
    noImagesAvailable: '没有可用的图片',
    noVideosAvailable: '没有可用的视频',
    noQuestionsAvailable: '没有可用的练习题',
    
    // Messages
    noTextFound: '未找到文本',
    processing: '处理中...',
    failed: '失败',
    success: '成功',
    error: '错误',
    loading: '加载中...',
    searchingImages: '搜索图片中...',
    generatingLessonPlan: '生成课程计划中...',
    convertingHandwriting: '转换手写中...',
    solving: '解决中...',
    explaining: '解释中...',
    noMathFound: '未找到数学表达式',
    mathSolverError: '解决数学问题失败',
    drawRectangleMath: '在数学问题周围画一个矩形',
    class: '班级',
    noTextToExplain: '未找到要解释的文本',
    explainError: '解释概念失败',
    drawRectangleExplain: '在要解释的概念周围画一个矩形',
    
    // AI Panel
    eeebeeAssistant: 'EeeBee 助手',
    aiPanelWelcome: '你好！我是 EeeBee，你的教育助手。我可以看到你的白板并帮助你解答任何问题。我可以解决数学问题、解释概念、分析白板上的内容，或者帮助你需要的任何其他事情！',
    eeebeeThinking: 'EeeBee 正在思考...',
    askAnything: '询问关于白板的任何问题...',
    
    // PPT Generator
    generatePPT: '生成PowerPoint',
    conceptsToLearn: '要学习的概念',
    conceptExplanation: '概念解释',
    
    // Educational Boards
    cbse: 'CBSE',
    icse: 'ICSE',
    ib: 'IB',
    cambridge: '剑桥',
    state: '州委员会',
    
    // Subjects
    mathematics: '数学',
    physics: '物理',
    chemistry: '化学',
    biology: '生物',
    english: '英语',
    computerScience: '计算机科学',
    history: '历史',
    geography: '地理',
    economics: '经济学',
    business: '商业研究',
    
    // Quiz Mode
    createNewQuiz: '创建新测验',
    generateAIPoweredQuiz: '生成具有可自定义设置的 AI 驱动测验',
    optional: '可选',
    numberOfQuestions: '问题数量',
    questions: '问题',
    timePerQuestion: '每题时间',
    seconds: '秒',
    minute: '分钟',
    minutes: '分钟',
    difficultyLevel: '难度级别',
    easy: '简单',
    medium: '中等',
    hard: '困难',
    mixed: '混合',
    questionTypes: '问题类型',
    multipleChoice: '多项选择',
    trueFalse: '真/假',
    mixedTypes: '混合类型',
    generateQuiz: '生成测验',
    difficulty: '难度',
    individualQuiz: '个人测验',
    startQuiz: '开始测验',
    backToSetup: '返回设置',
    question: '问题',
    of: '的',
    points: '分',
    hint: '提示',
    previous: '上一个',
    pause: '暂停',
    resume: '继续',
    finishQuiz: '完成测验',
    finish: '完成',
    continue: '继续',
    next: '下一个',
    quizResults: '测验结果',
    grade: '等级',
    correctAnswers: '正确答案',
    totalQuestions: '总题数',
    pointsEarned: '获得分数',
    questionBreakdown: '问题分解',
    yourAnswer: '您的答案',
    notAnswered: '未回答',
    correctAnswer: '正确答案',
    addToWhiteboard: '添加到白板',
    exportResults: '导出结果',
    takeAnotherQuiz: '参加另一个测验',
    aiQuizMode: 'AI 测验模式',
    pleaseSelectBoardGradeSubject: '请选择教育委员会、年级和学科',
    quizGeneratedSuccessfully: '测验生成成功！',
    quizResultsAddedToWhiteboard: '测验结果已添加到白板！',
    quizResultsExportedSuccessfully: '测验结果导出成功！',
    greatJob: '做得好！',
    learningOpportunity: '学习机会：',
    noExplanationAvailable: '此问题没有可用的解释',
    remember: '记住',
    clickContinueToNext: '点击继续进入下一个问题',
    
    // Concepts Panel
    chapterConcepts: '章节概念',
    analyzing: '分析中',
    generatingKeyConcepts: '生成关键概念以便更好地理解',
    startTeachingMode: '启动教学模式',
    closePanel: '关闭面板',
    examples: '示例',
    visualRepresentation: '视觉表示',
    visualLearning: '视觉学习',
    loadingVideos: '加载视频中...',
    loadingImages: '加载图片中...',
    testYourKnowledge: '测试您的知识',
    close: '关闭',
    clickToAddToBoard: '点击添加到白板',
    stopTeaching: '停止教学',
    pleaseWaitWhileFetchingContent: '请稍候，我们正在获取内容...'
  },
  
  de: {
    // Dock Toolbar
    select: 'Auswählen',
    draw: 'Zeichnen',
    highlighter: 'Textmarker',
    erase: 'Löschen',
    text: 'Text',
    undo: 'Rückgängig',
    redo: 'Wiederholen',
    deleteSelected: 'Ausgewähltes Löschen',
    handwritingToText: 'Handschrift zu Text',
    save: 'Speichern',
    clearAll: 'Alles Löschen',
    previousPage: 'Vorherige Seite',
    nextPage: 'Nächste Seite',
    addPage: 'Seite Hinzufügen',
    rectangle: 'Rechteck',
    circle: 'Kreis',
    triangle: 'Dreieck',
    line: 'Linie',
    backgroundThemes: 'Hintergrundthemen',
    
    // Context Menu
    eeebeeSmartTools: 'EeeBee Intelligente Werkzeuge',
    eeebeeTeach: 'EeeBee Lehren',
    findConcepts: 'Konzepte finden und erklären',
    mathSolver: 'Mathe-Löser',
    solveComplexEquations: 'Komplexe Gleichungen lösen',
    findImages: 'Bilder Suchen',
    searchSimilarImages: 'Ähnliche Bilder suchen',
    educationalVideos: 'Bildungsvideos',
    browseCurriculumVideos: 'Lehrplanvideos durchsuchen',
    '3dShapes': '3D-Formen',
    create3DGeometry: '3D-Geometrieformen erstellen',
    labSimulations: 'Laborsimulationen',
    virtualScienceExperiments: 'Virtuelle wissenschaftliche Experimente',
    comingSoon: 'Demnächst',
    learningAssistant: 'Lernassistent',
    aiPoweredHelp: 'KI-gestützte Hilfe',
    quizMode: 'Quiz-Modus',
    interactiveQuizzes: 'Interaktive Quizze',
    youtubeSearch: 'YouTube-Suche',
    searchYoutubeVideos: 'YouTube-Videos suchen',
    webSearch: 'Websuche',
    searchTheWeb: 'Im Web suchen',
    solveMath: 'Mathe Lösen',
    stepByStepSolutions: 'Schritt-für-Schritt-Lösungen',
    explainConcept: 'Konzept Erklären',
    detailedExplanations: 'Detaillierte Erklärungen',
    realWorldExamples: 'Beispiele aus der Realen Welt',
    practicalApplications: 'Praktische Anwendungen',
    copyText: 'Text Kopieren',
    copyScanText: 'Gescannten Text kopieren',
    
    // Learning Options
    learningOptions: 'Lernoptionen',
    explain: 'Erklären',
    provideDetailedExplanation: 'Detaillierte Erklärung bereitstellen',
    quiz: 'Quiz',
    createQuizQuestions: 'Quizfragen erstellen',
    realWorld: 'Reale Welt',
    showPracticalApplications: 'Praktische Anwendungen zeigen',
    youtubeVideos: 'YouTube-Videos',
    findEducationalVideos: 'Bildungsvideos finden',
    translate: 'Übersetzen',
    translateToLanguage: 'In eine andere Sprache übersetzen',
    copy: 'Kopieren',
    copyTextToClipboard: 'Text in die Zwischenablage kopieren',
    
    // AI Tools
    eeebeeAITools: 'EeeBee KI-Werkzeuge',
    aiAssistant: 'KI-Assistent',
    lessonPlanGenerator: 'Unterrichtsplan-Generator',
    
    // Settings
    educationSettings: 'Bildungseinstellungen',
    educationBoard: 'Bildungsrat',
    gradeLevel: 'Klassenstufe',
    subject: 'Fach',
    chapter: 'Kapitel',
    language: 'Sprache',
    selectBoard: 'Rat Auswählen',
    selectGrade: 'Klasse Auswählen',
    selectSubject: 'Fach Auswählen',
    allChapters: 'Alle Kapitel',
    showConcepts: 'Konzepte Anzeigen',
    openEbook: 'E-Book Öffnen',
    
    // Unified Concept Explainer
    explanation: 'Erklärung',
    visualAids: 'Visuelle Hilfsmittel',
    practiceQuestions: 'Übungsfragen',
    videos: 'Videos',
    practice: 'Übung',
    noImagesAvailable: 'Keine Bilder verfügbar',
    noVideosAvailable: 'Keine Videos verfügbar',
    noQuestionsAvailable: 'Keine Übungsfragen verfügbar',
    
    // Messages
    noTextFound: 'Kein Text gefunden',
    processing: 'Verarbeitung...',
    failed: 'Fehlgeschlagen',
    success: 'Erfolg',
    error: 'Fehler',
    loading: 'Laden...',
    searchingImages: 'Bilder werden gesucht...',
    generatingLessonPlan: 'Unterrichtsplan wird erstellt...',
    convertingHandwriting: 'Handschrift wird konvertiert...',
    solving: 'Lösung wird berechnet...',
    explaining: 'Erklärung wird erstellt...',
    noMathFound: 'Kein mathematischer Ausdruck gefunden',
    mathSolverError: 'Fehler beim Lösen des mathematischen Problems',
    drawRectangleMath: 'Zeichnen Sie ein Rechteck um das mathematische Problem',
    class: 'Klasse',
    noTextToExplain: 'Kein Text zum Erklären gefunden',
    explainError: 'Fehler beim Erklären des Konzepts',
    drawRectangleExplain: 'Zeichnen Sie ein Rechteck um das zu erklärende Konzept',
    
    // AI Panel
    eeebeeAssistant: 'EeeBee Assistent',
    aiPanelWelcome: 'Hallo! Ich bin EeeBee, Ihr Bildungsassistent. Ich kann Ihr Whiteboard sehen und Ihnen bei allen Fragen helfen. Ich kann mathematische Probleme lösen, Konzepte erklären, analysieren, was auf der Tafel steht, oder Ihnen bei allem anderen helfen, was Sie brauchen!',
    eeebeeThinking: 'EeeBee denkt nach...',
    askAnything: 'Fragen Sie etwas über das Whiteboard...',
    
    // PPT Generator
    generatePPT: 'PowerPoint Generieren',
    conceptsToLearn: 'Konzepte zum Lernen',
    conceptExplanation: 'Konzepterklärung',
    
    // Educational Boards
    cbse: 'CBSE',
    icse: 'ICSE',
    ib: 'IB',
    cambridge: 'Cambridge',
    state: 'Landesrat',
    
    // Subjects
    mathematics: 'Mathematik',
    physics: 'Physik',
    chemistry: 'Chemie',
    biology: 'Biologie',
    english: 'Englisch',
    computerScience: 'Informatik',
    history: 'Geschichte',
    geography: 'Geographie',
    economics: 'Wirtschaft',
    business: 'Betriebswirtschaftslehre',
    
    // Quiz Mode
    createNewQuiz: 'Neues Quiz Erstellen',
    generateAIPoweredQuiz: 'KI-gestütztes Quiz mit anpassbaren Einstellungen generieren',
    optional: 'Optional',
    numberOfQuestions: 'Anzahl der Fragen',
    questions: 'Fragen',
    timePerQuestion: 'Zeit pro Frage',
    seconds: 'Sekunden',
    minute: 'Minute',
    minutes: 'Minuten',
    difficultyLevel: 'Schwierigkeitsgrad',
    easy: 'Einfach',
    medium: 'Mittel',
    hard: 'Schwer',
    mixed: 'Gemischt',
    questionTypes: 'Fragetypen',
    multipleChoice: 'Multiple-Choice',
    trueFalse: 'Wahr/Falsch',
    mixedTypes: 'Gemischte Typen',
    generateQuiz: 'Quiz Generieren',
    difficulty: 'Schwierigkeit',
    individualQuiz: 'Individuelles Quiz',
    startQuiz: 'Quiz Starten',
    backToSetup: 'Zurück zur Einrichtung',
    question: 'Frage',
    of: 'von',
    points: 'Punkte',
    hint: 'Hinweis',
    previous: 'Vorherige',
    pause: 'Pause',
    resume: 'Fortsetzen',
    finishQuiz: 'Quiz Beenden',
    finish: 'Fertig',
    continue: 'Weiter',
    next: 'Nächste',
    quizResults: 'Quiz-Ergebnisse',
    grade: 'Note',
    correctAnswers: 'Richtige Antworten',
    totalQuestions: 'Gesamtzahl der Fragen',
    pointsEarned: 'Erhaltene Punkte',
    questionBreakdown: 'Fragenaufschlüsselung',
    yourAnswer: 'Ihre Antwort',
    notAnswered: 'Nicht beantwortet',
    correctAnswer: 'Richtige Antwort',
    addToWhiteboard: 'Zum Whiteboard Hinzufügen',
    exportResults: 'Ergebnisse Exportieren',
    takeAnotherQuiz: 'Ein Weiteres Quiz Machen',
    aiQuizMode: 'KI-Quiz-Modus',
    pleaseSelectBoardGradeSubject: 'Bitte wählen Sie Bildungsrat, Klassenstufe und Fach',
    quizGeneratedSuccessfully: 'Quiz erfolgreich generiert!',
    quizResultsAddedToWhiteboard: 'Quiz-Ergebnisse zum Whiteboard hinzugefügt!',
    quizResultsExportedSuccessfully: 'Quiz-Ergebnisse erfolgreich exportiert!',
    greatJob: 'Großartige Arbeit!',
    learningOpportunity: 'Lernmöglichkeit:',
    noExplanationAvailable: 'Keine Erklärung für diese Frage verfügbar',
    remember: 'Denken Sie daran',
    clickContinueToNext: 'Klicken Sie auf Weiter, um zur nächsten Frage zu gelangen',
    
    // Concepts Panel
    chapterConcepts: 'Kapitelkonzepte',
    analyzing: 'Analysieren',
    generatingKeyConcepts: 'Generierung von Schlüsselkonzepten für besseres Verständnis',
    startTeachingMode: 'Lehrmodus Starten',
    closePanel: 'Panel Schließen',
    examples: 'Beispiele',
    visualRepresentation: 'Visuelle Darstellung',
    visualLearning: 'Visuelles Lernen',
    loadingVideos: 'Videos werden geladen...',
    loadingImages: 'Bilder werden geladen...',
    testYourKnowledge: 'Testen Sie Ihr Wissen',
    close: 'Schließen',
    clickToAddToBoard: 'Klicken Sie, um zum Board hinzuzufügen',
    stopTeaching: 'Lehre Beenden',
    pleaseWaitWhileFetchingContent: 'Bitte warten Sie, während wir Inhalte abrufen...'
  },
  
  fr: {
    // Dock Toolbar
    select: 'Sélectionner',
    draw: 'Dessiner',
    highlighter: 'Surligneur',
    erase: 'Effacer',
    text: 'Texte',
    undo: 'Annuler',
    redo: 'Rétablir',
    deleteSelected: 'Supprimer la Sélection',
    handwritingToText: 'Écriture en Texte',
    save: 'Enregistrer',
    clearAll: 'Tout Effacer',
    previousPage: 'Page Précédente',
    nextPage: 'Page Suivante',
    addPage: 'Ajouter une Page',
    rectangle: 'Rectangle',
    circle: 'Cercle',
    triangle: 'Triangle',
    line: 'Ligne',
    backgroundThemes: 'Thèmes de Fond',
    
    // Context Menu
    eeebeeSmartTools: 'Outils Intelligents EeeBee',
    eeebeeTeach: 'EeeBee Enseigne',
    findConcepts: 'Trouver des concepts et expliquer',
    mathSolver: 'Solveur de Maths',
    solveComplexEquations: 'Résoudre des équations complexes',
    findImages: 'Rechercher des Images',
    searchSimilarImages: 'Rechercher des images similaires',
    educationalVideos: 'Vidéos Éducatives',
    browseCurriculumVideos: 'Parcourir les vidéos du programme',
    '3dShapes': 'Formes 3D',
    create3DGeometry: 'Créer des formes géométriques 3D',
    labSimulations: 'Simulations de Laboratoire',
    virtualScienceExperiments: 'Expériences scientifiques virtuelles',
    comingSoon: 'Bientôt Disponible',
    learningAssistant: 'Assistant d\'apprentissage',
    aiPoweredHelp: 'Aide par IA',
    quizMode: 'Mode Quiz',
    interactiveQuizzes: 'Quiz interactifs',
    youtubeSearch: 'Recherche YouTube',
    searchYoutubeVideos: 'Rechercher des vidéos YouTube',
    webSearch: 'Recherche Web',
    searchTheWeb: 'Rechercher sur le web',
    solveMath: 'Résoudre les Maths',
    stepByStepSolutions: 'Solutions étape par étape',
    explainConcept: 'Expliquer le Concept',
    detailedExplanations: 'Explications détaillées',
    realWorldExamples: 'Exemples du Monde Réel',
    practicalApplications: 'Applications pratiques',
    copyText: 'Copier le Texte',
    copyScanText: 'Copier le texte numérisé',
    
    // Learning Options
    learningOptions: 'Options d\'Apprentissage',
    explain: 'Expliquer',
    provideDetailedExplanation: 'Fournir une explication détaillée',
    quiz: 'Quiz',
    createQuizQuestions: 'Créer des questions de quiz',
    realWorld: 'Monde Réel',
    showPracticalApplications: 'Montrer les applications pratiques',
    youtubeVideos: 'Vidéos YouTube',
    findEducationalVideos: 'Trouver des vidéos éducatives',
    translate: 'Traduire',
    translateToLanguage: 'Traduire dans une autre langue',
    copy: 'Copier',
    copyTextToClipboard: 'Copier le texte dans le presse-papiers',
    
    // AI Tools
    eeebeeAITools: 'Outils AI EeeBee',
    aiAssistant: 'Assistant AI',
    lessonPlanGenerator: 'Générateur de Plan de Cours',
    
    // Settings
    educationBoard: 'Conseil d\'Éducation',
    gradeLevel: 'Niveau Scolaire',
    subject: 'Matière',
    chapter: 'Chapitre',
    language: 'Langue',
    selectBoard: 'Sélectionner le Conseil',
    selectGrade: 'Sélectionner le Niveau',
    selectSubject: 'Sélectionner la Matière',
    allChapters: 'Tous les Chapitres',
    showConcepts: 'Afficher les Concepts',
    openEbook: 'Ouvrir le Livre Électronique',
    
    // Unified Concept Explainer
    explanation: 'Explication',
    visualAids: 'Aides Visuelles',
    practiceQuestions: 'Questions d\'Exercice',
    videos: 'Vidéos',
    practice: 'Pratique',
    noImagesAvailable: 'Aucune image disponible',
    noVideosAvailable: 'Aucune vidéo disponible',
    noQuestionsAvailable: 'Aucune question d\'exercice disponible',
    
    // Messages
    noTextFound: 'Aucun texte trouvé',
    processing: 'Traitement...',
    failed: 'Échec',
    success: 'Succès',
    error: 'Erreur',
    loading: 'Chargement...',
    searchingImages: 'Recherche d\'images...',
    generatingLessonPlan: 'Génération du plan de cours...',
    convertingHandwriting: 'Conversion de l\'écriture...',
    solving: 'Résolution...',
    explaining: 'Explication...',
    noMathFound: 'Aucune expression mathématique trouvée',
    mathSolverError: 'Échec de la résolution du problème mathématique',
    drawRectangleMath: 'Dessinez un rectangle autour du problème mathématique',
    class: 'Classe',
    noTextToExplain: 'Aucun texte trouvé à expliquer',
    explainError: 'Échec de l\'explication du concept',
    drawRectangleExplain: 'Dessinez un rectangle autour du concept à expliquer',
    
    // AI Panel
    eeebeeAssistant: 'Assistant EeeBee',
    aiPanelWelcome: 'Bonjour! Je suis EeeBee, votre assistant pédagogique. Je peux voir votre tableau blanc et vous aider avec toutes vos questions. Je peux résoudre des problèmes mathématiques, expliquer des concepts, analyser ce qui est sur le tableau ou vous aider avec tout ce dont vous avez besoin!',
    eeebeeThinking: 'EeeBee réfléchit...',
    askAnything: 'Demandez n\'importe quoi sur le tableau blanc...',
    
    // PPT Generator
    generatePPT: 'Générer PowerPoint',
    conceptsToLearn: 'Concepts à Apprendre',
    conceptExplanation: 'Explication du Concept',
    
    // Educational Boards
    cbse: 'CBSE',
    icse: 'ICSE',
    ib: 'IB',
    cambridge: 'Cambridge',
    state: 'Conseil d\'État',
    
    // Subjects
    mathematics: 'Mathématiques',
    physics: 'Physique',
    chemistry: 'Chimie',
    biology: 'Biologie',
    english: 'Anglais',
    computerScience: 'Informatique',
    history: 'Histoire',
    geography: 'Géographie',
    economics: 'Économie',
    business: 'Études Commerciales',
    
    // Quiz Mode
    createNewQuiz: 'Créer un Nouveau Quiz',
    generateAIPoweredQuiz: 'Générer un quiz alimenté par IA avec des paramètres personnalisables',
    optional: 'Optionnel',
    numberOfQuestions: 'Nombre de Questions',
    questions: 'Questions',
    timePerQuestion: 'Temps par Question',
    seconds: 'secondes',
    minute: 'minute',
    minutes: 'minutes',
    difficultyLevel: 'Niveau de Difficulté',
    easy: 'Facile',
    medium: 'Moyen',
    hard: 'Difficile',
    mixed: 'Mixte',
    questionTypes: 'Types de Questions',
    multipleChoice: 'Choix Multiples',
    trueFalse: 'Vrai/Faux',
    mixedTypes: 'Types Mixtes',
    generateQuiz: 'Générer le Quiz',
    difficulty: 'Difficulté',
    individualQuiz: 'Quiz Individuel',
    startQuiz: 'Démarrer le Quiz',
    backToSetup: 'Retour à la Configuration',
    question: 'Question',
    of: 'de',
    points: 'points',
    hint: 'Indice',
    previous: 'Précédent',
    pause: 'Pause',
    resume: 'Reprendre',
    finishQuiz: 'Terminer le Quiz',
    finish: 'Terminer',
    continue: 'Continuer',
    next: 'Suivant',
    quizResults: 'Résultats du Quiz',
    grade: 'Note',
    correctAnswers: 'Réponses Correctes',
    totalQuestions: 'Total de Questions',
    pointsEarned: 'Points Obtenus',
    questionBreakdown: 'Détail des Questions',
    yourAnswer: 'Votre Réponse',
    notAnswered: 'Non répondu',
    correctAnswer: 'Réponse Correcte',
    addToWhiteboard: 'Ajouter au Tableau Blanc',
    exportResults: 'Exporter les Résultats',
    takeAnotherQuiz: 'Prendre un Autre Quiz',
    aiQuizMode: 'Mode Quiz IA',
    pleaseSelectBoardGradeSubject: 'Veuillez sélectionner le conseil d\'éducation, le niveau scolaire et la matière',
    quizGeneratedSuccessfully: 'Quiz généré avec succès!',
    quizResultsAddedToWhiteboard: 'Résultats du quiz ajoutés au tableau blanc!',
    quizResultsExportedSuccessfully: 'Résultats du quiz exportés avec succès!',
    greatJob: 'Excellent travail!',
    learningOpportunity: 'Opportunité d\'Apprentissage:',
    noExplanationAvailable: 'Aucune explication disponible pour cette question',
    remember: 'Rappelez-vous',
    clickContinueToNext: 'Cliquez sur Continuer pour passer à la question suivante',
    
    // Concepts Panel
    chapterConcepts: 'Concepts du Chapitre',
    analyzing: 'Analyse en cours',
    generatingKeyConcepts: 'Génération des concepts clés pour une meilleure compréhension',
    startTeachingMode: 'Démarrer le Mode Enseignement',
    closePanel: 'Fermer le Panneau',
    examples: 'Exemples',
    visualRepresentation: 'Représentation Visuelle',
    visualLearning: 'Apprentissage Visuel',
    loadingVideos: 'Chargement des vidéos...',
    loadingImages: 'Chargement des images...',
    testYourKnowledge: 'Testez Vos Connaissances',
    close: 'Fermer',
    clickToAddToBoard: 'Cliquez pour ajouter au tableau',
    stopTeaching: 'Arrêter l\'Enseignement',
    pleaseWaitWhileFetchingContent: 'Veuillez patienter pendant que nous récupérons le contenu...'
  }
};

// Language Context
const LanguageContext = createContext();

// Language Provider Component
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get saved language from localStorage or default to English
    return localStorage.getItem('appLanguage') || 'en';
  });

  // Save language preference when it changes
  useEffect(() => {
    localStorage.setItem('appLanguage', language);
  }, [language]);

  // Translation function
  const t = (key) => {
    return translations[language]?.[key] || translations['en'][key] || key;
  };

  // Get available languages
  const getAvailableLanguages = () => [
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'hi', name: 'हिन्दी', flag: '🇮🇳' },
    { code: 'es', name: 'Español', flag: '🇪🇸' },
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'zh', name: '中文', flag: '🇨🇳' },
    { code: 'de', name: 'Deutsch', flag: '🇩🇪' }
  ];

  const value = {
    language,
    setLanguage,
    t,
    getAvailableLanguages
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook to use language context
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;